//component uses as data source provider from sitecore
const Submenu = (): JSX.Element | null => {
  return null;
};

export default Submenu;
